declare global {
  interface Window {
    _fbq?: unknown;
    fbq?: {
      (...args: unknown[]): void;
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: (...args: unknown[]) => void;
    };
  }
}

let initialized = false;
const META_STANDARD_EVENT_MAP: Record<string, string> = {
  checkout_started: 'InitiateCheckout',
  payment_confirmed: 'Purchase',
  questionnaire_started: 'ViewContent',
};

function readEnv(key: string) {
  return typeof import.meta !== 'undefined' ? import.meta.env[key] : '';
}

function injectScript() {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById('gc-meta-pixel-script')) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.id = 'gc-meta-pixel-script';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Meta Pixel'));
    document.head.appendChild(script);
  });
}

function ensureFbq() {
  if (window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if (typeof fbq.callMethod === 'function') {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue = fbq.queue || [];
    fbq.queue.push(args);
  };
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  window.fbq = fbq;
  window._fbq = fbq;
}

export async function initMetaPixel() {
  const pixelId = readEnv('VITE_META_PIXEL_ID');
  if (!pixelId || typeof window === 'undefined') return false;
  if (initialized) return true;
  ensureFbq();
  await injectScript();
  window.fbq?.('init', pixelId);
  initialized = true;
  return true;
}

export function captureMetaPixelPageView() {
  if (!initialized) return;
  window.fbq?.('track', 'PageView');
}

export function captureMetaPixelEvent(
  name: string,
  properties?: Record<string, unknown>,
) {
  if (!initialized) return;
  const payload = properties || {};
  const standardEvent = META_STANDARD_EVENT_MAP[name];
  if (standardEvent) {
    window.fbq?.('track', standardEvent, payload);
  }
  window.fbq?.('trackCustom', name, payload);
}
